import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type {
  MembershipAccountPropertiesQuery,
  MembershipAccountPropertiesQueryVariables,
} from "~/generated/graphql";
import { GET_MEMBERSHIP_ACCOUNT_PROPERTIES } from "../providers/operations/membershipAccountProperties";

const useMembershipAccountPropertiesQuery = (
  email: string,
): UseQueryResult<
  MembershipAccountPropertiesQuery,
  MembershipAccountPropertiesQueryVariables
> => {
  return useQuery<
    MembershipAccountPropertiesQuery,
    MembershipAccountPropertiesQueryVariables
  >(GET_MEMBERSHIP_ACCOUNT_PROPERTIES, {
    variables: {
      email,
    },
  });
};

export default useMembershipAccountPropertiesQuery;
